export const colors = {
    azulMem: '#003876',
    rojoMem: '#ee333c'
}